<template>
  <div class="facial-harmonization-container">
    <div class="content-section">
      <h2 class="pb-2 border-bottom">Harmonização Facial</h2>
      <p>Equilíbrio, Simetria e Resultados Naturais</p>
      <p>
        Nossos tratamentos de harmonização facial são planejados para criar
        equilíbrio e beleza natural por meio de técnicas minimamente invasivas.
        Em vez de focar em um único traço, adotamos uma abordagem holística, que
        valoriza a harmonia global e a autoconfiança.
      </p>
      <h3>Principais tratamentos</h3>
      <ul>
        <li>
          Neuromoduladores — suavizam expressões para um aspecto renovado.
        </li>
        <li>
          Preenchimentos dérmicos — restauram volume e contorno em bochechas,
          lábios e mandíbula.
        </li>
        <li>
          Definição de queixo & mandíbula — melhora proporções e estrutura
          facial.
        </li>
        <li>
          Realce labial — resultados sutis ou volumosos, sempre personalizados.
        </li>
        <li>
          Rinoplastia não cirúrgica — refinamento do nariz com técnicas precisas
          de preenchedor.
        </li>
        <li>Suporte para olheiras & têmporas — devolve volume e suavidade.</li>
        <li>
          Lifting de maçãs do rosto — realce natural do terço médio da face.
        </li>
        <li>
          Skin boosters (PRP, bioestimuladores) — melhoram hidratação e
          qualidade da pele.
        </li>
        <li>
          Fios de PDO (opcional) — promovem efeito lifting sem cirurgia
          invasiva.
        </li>
      </ul>
      <h3>Visão geral do procedimento</h3>
      <ul>
        <li>
          Consulta & análise facial — avaliação personalizada e planejamento.
        </li>
        <li>
          Procedimento — técnicas seguras com anestesia local ou creme
          anestésico.
        </li>
        <li>
          Resultados imediatos — melhorias naturais com pouco ou nenhum
          downtime.
        </li>
        <li>
          Acompanhamento & cuidados — orientações para conforto e resultados
          duradouros.
        </li>
      </ul>
      <p>
        "A harmonização facial não é sobre mudar quem você é — mas sim sobre
        realçar sua beleza natural com equilíbrio, confiança e refinamento
        sutil."
      </p>
    </div>
    <div class="fh-videos">
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          margin-bottom: 1.5rem;
        "
        src="https://www.youtube.com/embed/dsy8tUMNyIs"
        title="YouTube Shorts: Harmonização Facial 1"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        "
        src="https://www.youtube.com/embed/LM2IEIQ-mC8"
        title="YouTube Shorts: Harmonização Facial 2"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "FacialHarmonizationContentPtBR",
};
</script>

<style scoped>
.facial-harmonization-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.fh-videos {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.fh-videos iframe {
  width: 320px;
  height: 568px;
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Responsive design */
@media (max-width: 768px) {
  .facial-harmonization-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .fh-videos {
    align-self: center;
  }

  .fh-videos iframe {
    width: 280px;
    height: 497px;
  }
}

@media (max-width: 480px) {
  .fh-videos iframe {
    width: 240px;
    height: 426px;
  }
}
</style>
